export default {
    pay: require('./pay').default,
    index() {
        return axios.get('/frontend/order');
    },
    store(data) {
        return axios.post('/frontend/order', data);
    },
}
